__webpack_require__.p = "/395_webdev/hexcalculator/";